var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradeLicenseDocIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25368_25025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 29.0001H13.25C13.0511 29.0001 12.8603 28.921 12.7197 28.7804C12.579 28.6397 12.5 28.449 12.5 28.2501V14.7501C12.5 14.5511 12.579 14.3604 12.7197 14.2197C12.8603 14.0791 13.0511 14.0001 13.25 14.0001H20.75L24.5 17.7501V28.2501C24.5 28.449 24.421 28.6397 24.2803 28.7804C24.1397 28.921 23.9489 29.0001 23.75 29.0001Z",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.0001V11.7501C15.5 11.5511 15.579 11.3604 15.7197 11.2197C15.8603 11.0791 16.0511 11.0001 16.25 11.0001H23.75L27.5 14.7501V25.2501C27.5 25.449 27.421 25.6397 27.2803 25.7804C27.1397 25.921 26.9489 26.0001 26.75 26.0001H24.5",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 22.2501H20.75",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 25.2501H20.75",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25368_25025"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8.00006,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeLicenseDocIcon);
export default __webpack_public_path__ + "static/media/tradeLicenseDocIcon.2be24251790b4de2803aaf9e43109e36.svg";
export { ForwardRef as ReactComponent };